module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/bookingWindow.svg?a1c0d62a";